import {
  GET_PAGE_CONTENT_SHORT_FAIL,
  GET_PAGE_CONTENT_SHORT_REQUEST,
  GET_PAGE_CONTENT_SHORT_SUCCESS,
  GET_PAGE_CONTENT_BY_ID_FAIL,
  GET_PAGE_CONTENT_BY_ID_REQUEST,
  GET_PAGE_CONTENT_BY_ID_SUCCESS,
  EDIT_PAGE_CONTENT_FAIL,
  EDIT_PAGE_CONTENT_REQUEST,
  EDIT_PAGE_CONTENT_SUCCESS,
  DEL_PAGE_CONTENT_FAIL,
  DEL_PAGE_CONTENT_REQUEST,
  DEL_PAGE_CONTENT_SUCCESS,
  ADD_PAGE_CONTENT_FAIL,
  ADD_PAGE_CONTENT_REQUEST,
  ADD_PAGE_CONTENT_SUCCESS
} from "./actions";
import { IPageContentShort, IPageContent } from "app/api/types";

interface IState {
  isLoading: boolean;
  pageList: IPageContentShort[];
  currentPage: IPageContent;
}
const initialState: IState = {
  pageList: [],
  currentPage: {
    pageId: "",
    pageTitle: "",
    content: []
  },
  isLoading: false
};

const mastersReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_PAGE_CONTENT_SHORT_REQUEST:
    case EDIT_PAGE_CONTENT_REQUEST:
    case GET_PAGE_CONTENT_BY_ID_REQUEST:
    case ADD_PAGE_CONTENT_REQUEST:
    case DEL_PAGE_CONTENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case GET_PAGE_CONTENT_SHORT_FAIL:
    case EDIT_PAGE_CONTENT_FAIL:
    case GET_PAGE_CONTENT_BY_ID_FAIL:
    case ADD_PAGE_CONTENT_FAIL:
    case DEL_PAGE_CONTENT_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case GET_PAGE_CONTENT_SHORT_SUCCESS:
      return {
        ...state,
        pageList: action.payload,
        isLoading: false
      };

    case EDIT_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case GET_PAGE_CONTENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentPage: action.payload
      };

    case ADD_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        pageList: [action.payload, ...state.pageList]
      };

    case DEL_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

export default mastersReducer;
